<template>
    <div class="Repairs">
        <Box title="科室报修">
            <FacilityDetails :data="{
            Images: require('@/assets/img/Icon_1.png'),
            EquName: $route&& $route.params&& $route.params.item ? $route.params.item.EquName:'',
            EquCode:  $route&& $route.params&& $route.params.item ?$route.params.item.EquCode:'',
            Size:  $route&& $route.params&& $route.params.item ?$route.params.item.EquType:'',
            EquNumber: $route&& $route.params&& $route.params.item ? $route.params.item.EquNumber:'',

        }" :hidden-department="true" />
            <Audio @AudioAddress='Sumdate(arguments[0])' :IsShowRecordImg='true' />
            <div class="infoBox">
                <p class="title">报修信息</p>
                <Field title="报修科室" name="departmentList" :text="DepartmentName" @manuconfirm="DepartmentId=arguments[0].a,
                DepartmentName=arguments[0].b" type="manufacturer" placeholder="请选择" />
                <Field title="报修人员" :text="RepairUserName" type="text" />

                <Field title="报修电话" placeholder="请输入" :text='RepairPhone' @onMessage="value => RepairPhone = value"
                    type='number' />

                <Field title="报修地址" placeholder="请输入" @onMessage="value => RepairAddress = value" />

                <!-- <Field title="故障问题" type="manufacturer" name="failureProblem" placeholder='请选择' @manuconfirm="FaultId=arguments[0].a,
                FaultName=arguments[0].b,FaultDesription=arguments[0].c" /> -->

                <!-- <input type="text" v-model="FaultName"/> -->
                <Field type="manufacturer" name="failureProblem"
                    @manuconfirm="FaultId=arguments[0].a,FaultName=arguments[0].b,FaultDesription=arguments[0].c"
                    title="故障问题" :text="FaultName" @input="value=>manuInputValue(value)" :SelectionAndInput='true' />

            </div>
            <div class="infoBox">
                <p class="title">故障描述<span>*</span></p>
                <textarea type="text" placeholder="请输入" cols="3" v-model="FaultDesription" />
            </div>
            <div class="infoBox">
                <p class="title">备注</p>
                <input type="text" placeholder="请输入" v-model="Remark" />
            </div>
            <ImgModule upload :deletable='true' @afterRead="afterRead(arguments[0])"
                @deleteImg="deleteImg(arguments[0])" />
        </Box>
        <Footer button="申请报修" @change="upload" />
    </div>
</template>

<script>
    import Audio from '../../components/Audio/AudioDefault.vue'
    import Box from '../../components/commonBox/commonBox'
    import FacilityDetails from '../../components/facilityDetails/facilityDetails'
    import Footer from '../../components/footer/footer'
    import Field from '../../components/field/field'
    import Bus from "../../components/bus/bus";
    import ImgModule from '../../components/imgModule/imgModule'

    export default {
        name: 'Repairs',
        data() {
            return {
                data: this.$route.params.item,
                RepairUserId: this.$UserInfo.UserId, //报修人
                RepairUserName: this.$UserInfo.UserName, //报修人名称
                DepartmentId: this.$route.params.item ? this.$route.params.item.DepartmentId : "", //报修科室Id
                DepartmentName: this.$route.params.item ? this.$route.params.item.DepartmentName : '', //报修科室名称
                RepairPhone: this.$UserInfo ? this.$UserInfo.Phone : '', //联系电话
                FaultId: '', //故障问题Id
                FaultName: '', //故障问题名称
                FaultDesription: '', //故障描述
                Remark: '', //备注
                RepairAddress: '', //报修地址
                RepairImageArray: [], //报修图片列表
                RepairImage: '', //报修图片字符串
                AudioUrl: '', //语音地址
            }
        },
        components: {
            Audio,
            Box,
            FacilityDetails,
            Footer,
            Field,
            ImgModule
        },
        beforeDestroy() {
            this.$Bus.$off('YSRKDelete');
        },
        mounted() {},
        methods: {
            Sumdate(e) {
                this.AudioUrl = e;
            },
            upload() {
                const data = {
                    EquId: this.data.EquCode,
                    EquName: this.data.EquName,
                    Store: this.$UserInfo.StoreCode,
                    RepairUserId: this.RepairUserId,
                    DepartmentId: this.DepartmentId,
                    DepartmentName: this.DepartmentName,
                    RepairPhone: this.RepairPhone,
                    FaultId: this.FaultId,
                    FaultName: this.FaultName,
                    FaultDesription: this.FaultDesription,
                    Remark: this.Remark,
                    RepairAddress: this.RepairAddress,
                    RepairImage: this.RepairImage,
                    Token: '123456',
                    AudioUrl: this.AudioUrl
                };
                if (!data.FaultDesription) {
                    this.$Toast('故障描述不能为空，请输入！');
                    return
                }
                this.$post('api/Repair/ApplyRepair', data).then(result => {
                    if (result.Status) {
                        this.$Toast('报修成功！', 1.5);
                        setTimeout(x => {
                            this.$router.go(-1);
                        }, 1000);
                    } else this.$Toast(result.Msg);
                })
            },
            afterRead(value) { //上传
                let data = {};
                value instanceof Array ? data = {
                    base64Str1: 1 <= value.length ? value[0].content : '',
                    base64Str2: 2 <= value.length ? value[1].content : '',
                    base64Str3: 3 <= value.length ? value[2].content : '',
                    base64Str4: 4 <= value.length ? value[3].content : '',
                    base64Str5: 5 <= value.length ? value[4].content : '',
                    base64Str6: 6 <= value.length ? value[5].content : '',
                    base64Str7: 7 <= value.length ? value[6].content : '',
                    base64Str8: 8 <= value.length ? value[7].content : '',
                    base64Str9: 9 <= value.length ? value[8].content : '',
                    base64Str10: 10 <= value.length ? value[9].content : '',
                } : data = {
                    base64Str1: value.content
                };
                this.ImgUpload(data);
            },
            deleteImg(value) { //删除图片
                this.RepairImageArray.splice(this.RepairImageArray.findIndex(x => x.DABH === value.DABH), 1);
                this.$Bus.$emit('YSRKDelete', this.RepairImageArray);
            },
            ImgUpload(ImgValue) { //报修图片上传
                this.$post('api/Repair/UploadImage', ImgValue,{
                    timeout:100000
                }).then(result => {
                    if (result.Status) {
                        this.RepairImage = result.ImagePath;
                        this.$Toast('报修图片上传成功!');
                    } else this.$Toast(result.Msg);
                })
            },
            manuInputValue(value) {
                this.FaultId = '';
                this.FaultName = value;
                this.FaultDesription = '';
            }
        },
        watch: {
            $route(to, from) {
                if (from.name === 'PropertySearch') {
                    this.staff = null
                    this.question = null
                    this.data = this.$route.params.item ? this.$route.params.item : {}
                }
            }
        }
    }
</script>

<style scoped lang="scss">
    .FieldItems {
        height: 112px;
        border-bottom: 2px solid #F3F3F3;
        display: flex;
        align-items: center;
        font-size: 29px;
        color: #858585;

        .action {
            color: $TEXT-DARK-COLOR;
        }

        .title {
            font-size: 30px;
            color: $TEXT-DARK-COLOR;
            flex: 1;
        }

        div {
            display: flex;
            align-items: center;

            img {
                width: 32px;
                height: 30px;
                margin-left: 8px;
            }
        }

        &:last-child {
            border: none
        }
    }

    .Repairs {
        padding-bottom: 112px;
    }

    .infoBox {

        textarea,
        input {
            font-size: 3.55vw;
            color: #666666;
        }
    }

    .infoBox span {
        color: #FF2947
    }
</style>



// WEBPACK FOOTER //
// src/page/repairs/repairs.vue